import { render } from "./RevenueMarginsReportView.vue?vue&type=template&id=289e4ff2"
import script from "./RevenueMarginsReportView.vue?vue&type=script&lang=js"
export * from "./RevenueMarginsReportView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__